/* eslint-disable react/jsx-props-no-spreading */
import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'

/**
 * Payment-method screen. **A stub — COM-949 fills it in.**
 *
 * Registered alongside its container type for the reason
 * `DeliveryDatePicker` states: the exhaustiveness assertion in
 * `BaseContainer` makes the union member and the `case` arm one change.
 *
 * **It fetches nothing on purpose.** COM-949 calls `useLazyGetCheckoutRule`
 * with `CheckoutRules.PAYMENT_METHODS` on mount and writes the pick through
 * `setCheckoutRuleSession`.
 *
 * ⚠️ **The pilot offers exactly one method, `CREDIT`.** Captured 2026-09-23
 * against a live session, contrary to COM-944's OQ-2, which records the rule
 * as an empty shell. So this screen has something real to render today — and
 * what it renders is a **single-option** selector.
 *
 * Whether a one-option radio list is the right control, or whether the screen
 * should be skipped when only one method exists, is a product question the
 * capture raises and does not settle. COM-949 should decide it deliberately
 * rather than inherit a list component that happens to draw one row.
 *
 * ⚠️ **A selection here does not reach `order.paymentMethod` yet.** The write
 * lands on `session.checkoutRules`, and widening `OrderPaymentMethods` to
 * carry it is COM-829 on the storefront side. Assert against the session, not
 * the order.
 *
 * ⚠️ **Per-item copy is a money leak if passed raw.** `PaymentMethodSelector`
 * in the library takes helper and tag strings per option — *"CASH — $50
 * surcharge"* — and `maskPricesForDisplay` is an allowlist over numeric props,
 * so it cannot see a price inside a string. Route both through the slot
 * pattern (`readSlotConfig` + `hidePrices` + `containsCurrencyMark`) the three
 * shipped panels already use.
 *
 * **No route exists in code.** Same as the delivery screen: the route, the
 * container and the navigation onto it are SCS config, authored by COM-951.
 */
const PaymentMethodSelector: FC<ITemplate> = ({ ...props }) => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])

  return <Default {...props} />
}

export default PaymentMethodSelector
